import { toJewishDate, toHebrewJewishDate } from "jewish-date";
import { hebrewDateType } from "../enums/hebrewDateType"; 


const useHebrewDate = () => {

    const getHebrewDate = (date, type = "full") => {

        if (!date)
            return 'Invalid Date';

        const jewishDate = toJewishDate(new Date(date));
        const hdate = toHebrewJewishDate(jewishDate)
        const hebrewDay = hdate.day;
        const hebrewMonth = hdate.monthName;
        const hebrewYear = hdate.year

        const getHebrewMonthsInGregorianMonth = () => {
            const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            const firstDayJewish = toJewishDate(firstDay);
            const lastDayJewish = toJewishDate(lastDay);
            const firstHebrewMonth = toHebrewJewishDate(firstDayJewish).monthName;
            const lastHebrewMonth = toHebrewJewishDate(lastDayJewish).monthName;
            return firstHebrewMonth === lastHebrewMonth ? `${firstHebrewMonth}` : `${firstHebrewMonth} - ${lastHebrewMonth}`
        };

        switch (type) {
            case hebrewDateType.day:
                return `${hebrewDay}`;
            case hebrewDateType.month:
                return `${hebrewMonth}`;
            case hebrewDateType.year:
                return `${hebrewYear}`;
            case hebrewDateType.full:
                return `${hebrewDay} ${hebrewMonth} ${hebrewYear}`;
            case hebrewDateType.fullMonth:
                return getHebrewMonthsInGregorianMonth();
            default:
                console.log('error coming to default on useHebrewDate comp');
        }
        return `${hebrewDay} ${hebrewMonth} ${hebrewYear}`;
    };

    return getHebrewDate;
};

export default useHebrewDate;
